export const ACCOUNTS = [
  // Asset
  "帳戶-SBJ-長X",
  "帳戶-東京之星-長X",
  "帳戶-SBJ-XX仁",
  "帳戶-郵儲-XX仁",
  "帳戶-東京之星-XX仁",
  "帳戶-東京之星-XX榮",
  "帳戶-東京之星-谷XX",
  "帳戶-東京之星-XX則",
  "帳戶-樂天",
  "帳戶-現金",
  "帳戶-東京之星-XX榮-美金",
  "帳戶-東京之星-谷XX-美金",
  "帳戶-SMBC-長X",
  "帳戶-樂天證券-XX仁",
  "帳戶-物管-Smart Partners",
  "帳戶-物管-Ichigo House",
  "金融資產",
  "土地",
  "建物",
  "設備",
  "預付訂金",
  "預付稅費",

  // Liability
  "貸款",
  "保證金",
  "應付費用",
  "應付稅金",

  // Equity
  "資本金",
  "保留盈餘",

  // Revenue
  "租金收入",
  "管理費收入",
  "其他固定收入",

  // Expense
  "源泉稅",
  "管理費與修繕積立金",
  "水電通訊費",
  "物件手續費",
  "其他固定運營費用",

  "利息費用",
  "固都稅",

  "物件一次性收入",
  "設備營繕費用",
  "其他一次性運營費用",
  "非運營費用",
  "不動產買賣費用",

  "人事費用",
  "租賃費用",
  "水電費",
  "通訊費用",
  "交際費用",
  "交通差旅費用",
  "專業服務費用",
  "辦公費用",
  "手續費",
  "員工日常費用",

  "業務委託費用",
  "XX仁薪資",

  "利息收入",
  "投資損益",

  "股東消費費用",
  "匯兌損益",
  "其他業外損益",

  "所得稅",
  "消費稅",
  "印花稅",
  "其他稅金",
] as const;

export type Account = typeof ACCOUNTS[number];

export interface JournalEntry {
  date: Date;
  description: string;
  account: Account;
  property: string;
  tenant?: string;
  note?: string;

  creditAmount?: number;
  debitAmount?: number;
}

export interface ParseResult {
  property: Property;
  reportDate: Date;

  // Each subarray represents journal entries with the same journal id.
  journalEntryGroups: Array<Array<JournalEntry>>;

  // The sum for each table type. For example, this is "入金額" in the 收入 table.
  sums: Map<TableType, number>;
}

export type RawCellDatum = string | number | boolean | null | undefined;

export interface FileParser {
  parse(data: Uint8Array): ParseResult;
}

export const TABLE_TYPES = [
  '收入',
  '其他收入',
  '支出',
] as const;

export type TableType = typeof TABLE_TYPES[number];

export const PROPERTIES = [
  '三軒茶屋',
  '目黑',
  '茅場町',
  '大井町',
] as const;

export type Property = typeof PROPERTIES[number];

export function isProperty(s: string): s is Property {
  return PROPERTIES.includes(s as Property);
}
